export default __webpack_public_path__ + "static/media/primenet-logo.2ce6ff63.png";